import React, { useEffect, useState } from 'react';
import { marked } from 'marked';

const Changelog: React.FC = () => {
  const [content, setContent] = useState<string>('');

  useEffect(() => {
    const fetchMarkdown = async () => {
      try {
        const response = await fetch('/CHANGELOG.MD');
        if (!response.ok) {
          throw new Error('Erro ao buscar o arquivo CHANGELOG.md');
        }
        const text = await response.text();
        setContent(await marked(text));
      } catch (error) {
        console.error(error);
      }
    };

    fetchMarkdown();
  }, []);

  return (
    <div className="mt-4">
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};

export default Changelog;
